;(function () {
  let covetPicsProducts = []
  let gtagItemData = {}

  document.addEventListener('galleryReady:covetPics', function (e) {
    // console.log('galleryReady:covetPics', e)
    /* 配置右侧内容区域样式 */
    const stylesPopup = document.createElement('style')
    stylesPopup.innerHTML = `
      .popup-body {
        overflow-y: initial!important;
      }
      .btn-checkout {
        display: none!important;
      }
      .icon-shopping-bag {
        position: absolute;
        display: block;
        top: 32px;
        left: 20px;
        width: 20px;
        height: 20px;
        cursor: pointer; 
      }
      .icon-shopping-bag sup.count {
        position: absolute;
        display: block;
        top: -6px;
        right: -8px;
        width: 16px;
        height: 16px;
        line-height: 16px;
        font-size: 12px;
        font-weight: bold;
        font-style: normal;
        text-align: center;
        color: #000000;
        background-color: #94c93d;
        border-radius: 50%
      }
      .links .product-link {
        height: auto!important;
        cursor: pointer;
      }
      .links .product-link.sold-out {
        padding-bottom: 0;
        margin-bottom: 0;
      }
      .links .btn-buy.sold-out {
        pointer-events: none;
        min-height: auto;
        background-color: transparent;
        color: #000;
        font-weight: bold;
      }
      .links .product-title {
        opacity: 0;
      }
      .links .product-color {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        list-style: none;
        padding-left: 0;
        margin-bottom: 12px;
        cursor: pointer;
      }
      .links .product-color li {
        position: relative;
        width: 16px;
        height: 16px;
        margin: 3px;
        border-radius: 50%;
        border: 1px solid #cccccc;
        box-sizing: border-box;
        transition: all .3s;
      }
      .links .product-color li.active,
      .links .product-color li:hover {
        border: 1px solid #999999;
      }
      .links .product-color li span {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: block;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        transition: all .3s;
      }
      .links .product-color li.active span,
      .links .product-color li:hover span {
        width: 10px;
        height: 10px;
      }
    `
    const cpPopup = document.querySelector('covet-pics-popup')
    const popupRoot = cpPopup.shadowRoot
    popupRoot.appendChild(stylesPopup)
  })

  function setProductSoldOut(dom) {
    dom.addClass('sold-out').removeAttr('href')
    dom.siblings('.btn-buy ').addClass('sold-out').html(`<span class="btn-title">SOLD OUT</span>`)
  }

  async function enhanceCoverPics() {
    covetPicsProducts = []
    const moduleTheme = window.MODULE_THEME
    const productColors = moduleTheme?.productColors || {}
    const cpPopup = document.querySelector('covet-pics-popup')
    $(cpPopup).css('z-index', 9999999)
    const popupRoot = cpPopup.shadowRoot

    const cpLinks = popupRoot.querySelector('covet-pics-popup-links')
    const productLink = $(cpLinks).find('.product-link')
    productLink.attr('target', '_blank')

    /* 设置购物袋icon */
    if (productLink.length) {
      const popupBodScroll = popupRoot.querySelector('.popup-body-content-scroll')
      const Cart = window.MinimogTheme?.Cart || {}
      const shoppingBagIcon = `<i class="icon-shopping-bag">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" height="16px"><path d="M352 128C352 57.42 294.579 0 224 0 153.42 0 96 57.42 96 128H0v304c0 44.183 35.817 80 80 80h288c44.183 0 80-35.817 80-80V128h-96zM224 48c44.112 0 80 35.888 80 80H144c0-44.112 35.888-80 80-80zm176 384c0 17.645-14.355 32-32 32H80c-17.645 0-32-14.355-32-32V176h48v40c0 13.255 10.745 24 24 24s24-10.745 24-24v-40h160v40c0 13.255 10.745 24 24 24s24-10.745 24-24v-40h48v256z"></path></svg>
        <sup class="count">${Cart?.cart?.item_count || 0}</sup>
      </i>`
      $(popupBodScroll).prepend(shoppingBagIcon)
      $(popupBodScroll)
        .find('.icon-shopping-bag')
        .click(function () {
          Cart.openCartDrawer()
        })
    }

    /* 设置商品颜色切换dot */
    if (productLink.length) {
      const handles = []
      for (const item of productLink) {
        const href = $(item).attr('href')
        const path = href.split('/').pop()
        handles.push(path)
      }
      for (const [index, item] of handles.entries()) {
        try {
          const response = await fetch(`/products/${item}.js`)
          const data = await response.json()
          covetPicsProducts.push(data)

          const colorOption = data.options.find((e) => e.name === 'Color')
          const colorList = colorOption?.values || []
          let colorOptionHtml = ''
          for (let [sindex, sitem] of colorList.entries()) {
            const color = sitem?.replace(/\s+/g, '').toLocaleLowerCase()
            colorOptionHtml += `<li class="${
              sindex ? '' : 'active'
            }" data-parent-index="${index}" data-color="${color}">
              <span style="background-color: ${productColors[color]}"></span>
            </li>`
          }
          const currentProductLink = productLink.eq(index)
          let colorOptionsHtml = `<ul class="product-color">${colorOptionHtml}</ul>`
          currentProductLink.children('.product-details').before(colorOptionsHtml)
          const variants = data.variants
          currentProductLink.find('.product-img').attr('src', variants[0]?.featured_image?.src)
          const distinguishOriginality = moduleTheme?.distinguishOriginality || false
          let isOriginal = data.tags.includes('Original')
          if (distinguishOriginality && !isOriginal) {
            let title = data.title.replace('Thesupermade', '').replace('The Supermade', '').trim()
            const titleDom = currentProductLink.find('.product-title')
            titleDom?.html(title).css({ opacity: 1 })
          }

          if (!data.available) {
            setProductSoldOut(currentProductLink)
          }
        } catch (error) {
          console.error('Error fetching product:', error)
          covetPicsProducts.push({})
          setProductSoldOut(productLink.eq(index))
        }
      }
      $(cpLinks)
        .find('.product-color')
        .click(function (e) {
          e.preventDefault()
        })
      $(cpLinks)
        .find('.product-color')
        .on('click', 'li', function () {
          const pindex = $(this).data('parent-index')
          const color = $(this).data('color')?.toLocaleLowerCase() || ''
          const variants = covetPicsProducts[pindex]?.variants || []
          const variant = variants.find((e) => e.title.replace(/\s+/g, '')?.toLocaleLowerCase()?.includes(color))
          productLink.eq(pindex).find('.product-img').attr('src', variant?.featured_image?.src)
          $(this).addClass('active').siblings('li').removeClass('active')
        })
    }
  }

  document.addEventListener('modalOpen:covetPics', function (e) {
    console.log('modalOpen:covetPics', e)
    enhanceCoverPics()
  })

  document.addEventListener('modalChanged:covetPics', function (e) {
    console.log('modalChanged', e)
    enhanceCoverPics()
  })

  document.addEventListener('openDirectBuy', async function (e) {
    console.log('openDirectBuy', e)
    const cpPopup = document.querySelector('covet-pics-popup')
    const popupRoot = cpPopup.shadowRoot

    /* Google Ga4 Code - Event: view_item */
    const pidx = covetPicsProducts.findIndex((v) => v.id == e.detail)
    let product = {}
    // console.log('covetPicsProducts', covetPicsProducts, pidx)
    if ((window.gtag, pidx !== -1)) {
      product = covetPicsProducts[pidx] || {}
      let categoryObject = {}
      const moduleGtag = window.MOUDLE_GTAG
      if (moduleGtag) {
        let affiliation = moduleGtag?.getGtagAffiliation(product.tags, product.type, product.vendor)
        categoryObject = affiliation?.categories || {}
      }
      const item = {
        item_name: product.title,
        index: pidx + 1,
        item_list_id: `look_book`,
        item_list_name: `Look Book`,
        item_brand: 'thesupermade',
        quantity: 1,
        ...categoryObject
      }
      const variants = product.variants || []
      const availableVariants = variants?.find((e) => e.available) || variants[0] || {}
      const discounts = product.discount || []
      let discount = 0
      let allCoupon = []
      if (discounts.length) {
        allCoupon = discounts.map((discount) => discount?.title || '')
        discount = discounts.reduce((sum, discount) => {
          return (sum += discount?.amount)
        }, 0)
      }
      const coupon = allCoupon.length ? allCoupon.join('_') : ''
      gtagItemData = {
        variants,
        params: item,
        discount,
        coupon
      }
      const items = [
        {
          item_id: availableVariants.id + '',
          item_variant: availableVariants?.public_title,
          price: (availableVariants?.price || 0) / 100,
          ...item
        }
      ]
      gtag('event', 'view_item', {
        currency: Shopify.currency?.active,
        value: item.price,
        items: items
      })
    }

    /* 配置加购样式 */
    const observer = new MutationObserver((mutations) => {
      // console.log('mutations', mutations)
      const cpBuy = popupRoot.querySelector('covet-pics-direct-buy')
      const hasStyle = $(cpBuy).data('has-style')
      if (cpBuy && !hasStyle) {
        const stylesBuy = document.createElement('style')
        const buyRoot = cpBuy.shadowRoot
        stylesBuy.innerHTML = `
          .wrap .main {
            padding-bottom: 48px;
          }
          .wrap .main .title a {
            opacity: 0;
          }
          .wrap .footer {
            position: relative;
            margin: 0 var(--covet-pics-padding-size);
            width: auto;
            bottom: auto;
            background: transparent;
            padding-bottom: 20px;
          }
          .wrap .footer .price-wrap {
            width: 100%;
            justify-content: end;
            padding: 0;
            margin-bottom: 10px;
            background: transparent;
            font-size: 16px;
          }
          .wrap .footer .price-wrap label {
            padding-right: 10px;
          }
          .wrap .footer .btn-buy {
            padding: 14px;
          }
          .wrap .footer .btn-buy.disabled {
            background: rgb(238, 238, 238);
            color: rgb(128, 128, 128);
            pointer-events: none;
          }
        `
        buyRoot.appendChild(stylesBuy)
        const btnBuy = buyRoot.querySelector('.btn-buy')
        const optionNames = $(buyRoot).find('.option-name')
        let optionHtml = ''
        for (let item of optionNames) {
          optionHtml += optionHtml.length ? ' / ' + item.innerHTML : item.innerHTML
        }
        $(btnBuy).addClass('disabled').html(`Please Choose ${optionHtml}`)

        const moduleTheme = window.MODULE_THEME
        let distinguishOriginality = moduleTheme?.distinguishOriginality || false
        let isOriginal = product.tags?.includes('Original')
        let titleDom = buyRoot.querySelector('.title a')
        if (distinguishOriginality && !isOriginal) {
          let title = product.title?.replace('Thesupermade', '').replace('The Supermade', '').trim()
          $(titleDom)?.html(title)
        }
        $(titleDom).css({ opacity: 1 })

        const optionObserver = new MutationObserver(() => {
          const option = buyRoot.querySelector('.selected-option')
          if (option) {
            const options = $(buyRoot).find('.selected-option')
            let flag = true
            for (let item of options) {
              if (item.innerHTML?.toLocaleLowerCase() === 'select') {
                flag = false
              }
            }
            if (flag) {
              $(btnBuy).removeClass('disabled').html('Add To Cart')
              optionObserver.disconnect()
            }
          }
        })
        optionObserver.observe(buyRoot, { childList: true, subtree: true })

        if (window.gtag) {
          /* Google Ga4 Code - Event: view_item */
          const gtagObserver = new MutationObserver(() => {
            const option = buyRoot.querySelector('.selected-option')
            if (option) {
              const options = $(buyRoot).find('.selected-option')
              let flag = true
              let optionValue = []
              for (let item of options) {
                if (item.innerHTML?.toLocaleLowerCase() === 'select') {
                  flag = false
                }
                optionValue.push(item.innerHTML)
              }
              if (flag) {
                // console.log('optionValue', optionValue)
                const currentVariant = gtagItemData.variants?.find((e) => {
                  const covertValue = optionValue.join(' / ')
                  if (optionValue.length < e.options.length) {
                    return e.public_title.includes(covertValue)
                  }
                  return e.public_title === covertValue
                })
                if (currentVariant) {
                  const item = {
                    item_id: currentVariant?.id + '',
                    item_variant: currentVariant?.public_title,
                    price: (currentVariant?.price || 0) / 100,
                    ...gtagItemData.params
                  }
                  gtag('event', 'view_item', {
                    currency: Shopify.currency?.active,
                    value: item.price,
                    items: [item]
                  })
                }
              }
            }
          })
          gtagObserver.observe(buyRoot, { childList: true, subtree: true })
        }
      }
      observer.disconnect()
    })
    observer.observe(popupRoot, { childList: true, subtree: true })
  })

  document.addEventListener('addToCart:covetPics', function (e) {
    console.log('addToCart', e)
    /* 触发Cart Drawer更新并弹出 */
    window.Shopify.onCartUpdate(window.MinimogTheme?.Cart?.cart, true)

    /* Google Ga4 Code - Event: add_to_cart */
    if (window.gtag) {
      const variantId = e.detail?.variantId
      const currentVariant = gtagItemData.variants?.find((e) => e.id == variantId)
      const item = {
        item_id: currentVariant?.id + '',
        item_variant: currentVariant?.public_title,
        price: (currentVariant?.price || 0) / 100,
        coupon: gtagItemData.coupon,
        discount: gtagItemData.discount,
        ...gtagItemData.params
      }
      gtag('event', 'add_to_cart', {
        currency: Shopify.currency?.active,
        value: item.price,
        button_name: 'add_to_cart',
        items: [item]
      })
    }
  })
})()
